export default __webpack_public_path__ + "static/media/LOGO.c21df73a.png";